import type { Formation } from '../types/formation'

export const formations: Formation[] = [
  {
    slug: 'numeriser-son-entreprise',
    titre: 'Numériser son entreprise à l’ère du digital',
    categorie: 'Digital & communication',
    promesse:
      'Structurer votre présence en ligne, professionnaliser vos réseaux sociaux et exploiter les outils numériques utiles à votre activité.',
    presentation:
      'Un parcours complet pour passer d’une présence en ligne improvisée à une communication digitale claire et pilotée. Vous travaillez sur votre propre activité : plateformes, messages, contenus, outils numériques et intelligence artificielle, puis mesure des résultats. Formation dispensée en présentiel à Joigny (Yonne).',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/dcfa48cb-cdd8-453d-99f0-c5f977c0069d.jpg',
    publicConcerne:
      'Entrepreneurs, commerçants, indépendants, dirigeants et salariés souhaitant développer leur visibilité en ligne et structurer leur communication digitale.',
    duree: '9 jours — 63 heures',
    tarif: '1 700 €',
    prerequis: 'Aucun prérequis demandé.',
    format: 'Présentiel',
    lieu: 'Zillenium Academy — 25 rue Gabriel Cortel, 89300 Joigny',
    delaiAcces: '14 jours après validation de l’inscription',
    objectifs: [
      'Comprendre l’écosystème digital et ses usages professionnels.',
      'Développer sa visibilité et clarifier sa présence en ligne.',
      'Utiliser les réseaux sociaux de manière professionnelle.',
      'Créer des contenus adaptés à son activité et à ses publics.',
      'Découvrir l’intelligence artificielle et les outils numériques utiles à l’activité.',
      'Mesurer les résultats et optimiser ses actions.',
    ],
    programme: [
      'Usages, plateformes et enjeux du digital.',
      'Stratégie digitale cohérente et adaptée.',
      'Présence professionnelle sur les réseaux sociaux.',
      'Publications, messages et supports de communication.',
      'Outils numériques et intelligence artificielle.',
      'Mesure, analyse et amélioration des actions.',
    ],
    methodes: ['Apports', 'Démonstrations', 'Ateliers', 'Cas pratiques'],
    evaluation: ['Quiz', 'Cas pratiques', 'Mises en situation', 'Évaluation finale'],
    sanction: 'Attestation de fin de formation / de réalisation.',
  },
  {
    slug: 'piloter-son-point-de-vente',
    titre: 'Piloter efficacement son point de vente',
    categorie: 'Commerce & organisation',
    promesse:
      'Reprendre la main sur l’organisation du magasin : priorités terrain, flux, stocks, management quotidien et indicateurs commerciaux.',
    presentation:
      'Trois jours pour outiller les responsables de point de vente sur ce qui se joue au quotidien : arbitrer les priorités, fluidifier l’organisation, encadrer l’équipe, absorber les imprévus et lire les bons indicateurs pour décider. Formation ouverte aux commerces de Joigny et de l’Yonne, en présentiel, distanciel ou format mixte.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/a81173c7-ff58-48e4-ad6b-25db83d15840.jpg',
    publicConcerne:
      'Responsables de magasin, commerçants, managers et salariés souhaitant renforcer l’organisation commerciale et la gestion des imprévus.',
    duree: '3 jours — 21 heures',
    tarif: '525 €',
    prerequis: 'Aucun prérequis demandé.',
    format: 'Présentiel, distanciel ou mixte selon l’organisation',
    lieu: 'Dans vos locaux, à Joigny (89) ou à distance selon l’organisation retenue',
    delaiAcces: '14 jours après validation de l’inscription',
    objectifs: [
      'Piloter l’activité commerciale et les priorités terrain.',
      'Optimiser les flux, stocks et ressources disponibles.',
      'Structurer le management opérationnel quotidien.',
      'Réagir efficacement aux imprévus.',
      'Analyser les indicateurs commerciaux.',
      'Mettre en œuvre une démarche d’amélioration continue.',
    ],
    programme: [
      'Organisation du point de vente et responsabilités.',
      'Gestion des flux, stocks et priorités.',
      'Management opérationnel et coordination.',
      'Imprévus et continuité d’activité.',
      'Indicateurs commerciaux et performance.',
      'Amélioration de l’organisation et de l’expérience client.',
    ],
    methodes: ['Apports', 'Études de cas', 'Simulations', 'Mises en situation'],
    evaluation: ['Cas pratiques', 'Simulations', 'Mises en situation', 'Évaluation finale'],
    sanction: 'Attestation de fin de formation / de réalisation.',
  },
  {
    slug: 'booster-son-projet-et-sa-communication',
    titre: 'Booster son projet et sa communication',
    categorie: 'Entrepreneuriat & projet',
    promesse:
      'Structurer votre projet, clarifier votre positionnement et construire une communication qui se comprend en une phrase.',
    presentation:
      'Un accompagnement long format pour transformer une idée en projet cadré : objectifs réalistes, compréhension du marché et des publics, proposition de valeur, puis communication et contenus professionnels. Le parcours alterne coaching collectif et travail sur votre propre projet, avec un plan d’action suivi dans le temps.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/e2c248ed-ae83-422b-9d62-2cb232938548.jpg',
    publicConcerne:
      'Créateurs d’entreprise, porteurs de projet, associations et entrepreneurs souhaitant structurer leur projet et rendre leur communication plus claire.',
    duree: '77 heures',
    dureeNote:
      'Nombre de jours à confirmer avant publication : le document source est ambigu sur ce point. Le volume horaire de 77 heures est confirmé.',
    tarif: '5 500 €',
    prerequis: 'Aucun prérequis demandé.',
    format: 'Présentiel, distanciel ou mixte selon l’organisation',
    lieu: 'Joigny (89), dans vos locaux ou à distance selon l’organisation retenue',
    delaiAcces: '14 jours après validation de l’inscription',
    objectifs: [
      'Structurer un projet professionnel et définir des objectifs réalistes.',
      'Comprendre son marché, ses publics et ses priorités.',
      'Clarifier son positionnement et sa proposition de valeur.',
      'Développer une stratégie de communication adaptée.',
      'Produire des contenus professionnels et organiser le suivi des actions.',
    ],
    programme: [
      'Définition du projet, objectifs, besoins et priorités.',
      'Étude de marché et compréhension des publics.',
      'Positionnement, offre et proposition de valeur.',
      'Communication, messages, supports et réseaux sociaux.',
      'Création de contenus lisibles et professionnels.',
      'Plan d’action, priorisation et suivi de l’avancement.',
    ],
    methodes: ['Coaching collectif', 'Ateliers', 'Travaux pratiques', 'Études de cas'],
    evaluation: ['Présentation de projet', 'Plan d’action', 'Évaluation finale'],
    sanction: 'Attestation de fin de formation / de réalisation.',
  },
  {
    slug: 'management-commercial',
    titre: 'Management commercial : encadrer et transmettre',
    categorie: 'Management',
    promesse:
      'Asseoir une posture managériale claire, animer son équipe et faire progresser ses collaborateurs en environnement commercial.',
    presentation:
      'Trois jours centrés sur la pratique du management commercial : communication adaptée aux profils, responsabilisation, transmission des savoir-faire, prévention des tensions et pilotage des objectifs collectifs. Le parcours s’appuie sur des jeux de rôle et des situations réelles apportées par les participants.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/d24a548b-ce88-40f1-b8e8-467177217465.jpg',
    publicConcerne:
      'Managers, responsables d’équipe, dirigeants et encadrants souhaitant accompagner efficacement leurs collaborateurs dans un environnement commercial.',
    duree: '3 jours — 21 heures',
    tarif: '2 500 €',
    prerequis: 'Expérience professionnelle souhaitée.',
    format: 'Présentiel, distanciel ou mixte selon l’organisation',
    lieu: 'Joigny (89), dans vos locaux ou à distance selon l’organisation retenue',
    delaiAcces: '14 jours après validation de l’inscription',
    objectifs: [
      'Développer une posture managériale claire et mobilisatrice.',
      'Adapter sa communication aux profils et aux situations.',
      'Animer une équipe et responsabiliser les collaborateurs.',
      'Accompagner la montée en compétences individuelle.',
      'Prévenir les tensions et gérer les situations délicates.',
    ],
    programme: [
      'Fondamentaux du management commercial.',
      'Communication managériale adaptée.',
      'Organisation, motivation et responsabilisation.',
      'Transmission et montée en compétences.',
      'Prévention et traitement des conflits.',
      'Pilotage des objectifs et dynamique collective.',
    ],
    methodes: ['Jeux de rôle', 'Simulations', 'Études de cas', 'Ateliers pratiques'],
    evaluation: ['Mises en situation', 'Cas pratiques', 'Évaluation des compétences'],
    sanction: 'Attestation de fin de formation / de réalisation.',
  },
]

export function getFormation(slug: string): Formation | undefined {
  return formations.find((f) => f.slug === slug)
}
